<template>
  <pt-production-task-form class="pt-production-task-form__page"></pt-production-task-form>
</template>

<script>
import PtProductionTaskForm from 'cps/production-task/pt-production-task-form/withData'
export default {
  name: 'pt-production-task-form__view',
  components: {
    'pt-production-task-form': PtProductionTaskForm
  }
}
</script>
